import {Component, OnDestroy, OnInit} from '@angular/core';
import { CompanyService, FirebaseService} from "@brightside-web/desktop/data-access/shared";
import {from, Subscription, forkJoin} from "rxjs";
import {Router} from "@angular/router";

import {
  BsAuthService,
  BsCacheService
} from "@brightside-web/desktop/data-access/core-services";

import {RegistrationService} from "@brightside-web/desktop/data-access/onboarding";
import {LanguageSelectorService} from "@brightside-web/desktop/feature/language-selection";

@Component({
  selector: 'brightside-web-indentity',
  templateUrl: './identity.component.html',
  styleUrls: ['./identity.component.scss']
})
export class IdentityComponent implements OnInit, OnDestroy {

  sub = new Subscription();
  company: string;
  employmentType: string;
  customerType: string;
  titleKey = 'VERIFY_ELIGIBILITY_TITLE';
  bodyKey = 'VERIFY_ELIGIBILITY_DESC';
  regType: string;
  redirectTimeout: number;
  referrerType: string;
  private getProfileTimeout = 0;

  constructor(
    private companyService: CompanyService,
    private router: Router,
    private analytics: FirebaseService,
    private regSvc: RegistrationService,
    private languageSelectSvc: LanguageSelectorService,
    private bsAuthService: BsAuthService,
    private bsCacheService: BsCacheService
  ) {

    forkJoin([
      from(this.bsCacheService.getItem('customerType')),
      from(this.bsCacheService.getItem('registrationType')),
      from(this.bsCacheService.getItem('referrerType')),
      from(this.bsCacheService.getItem('employmentType'))
    ]).subscribe(
      ([customerType, registrationType, referrerType, employmentType]) => {

        this.customerType = customerType;
        this.regType = registrationType ?? 'regular';
        this.referrerType = referrerType ?? '';
        this.employmentType = employmentType;

        if (this.employmentType === 'dependent') {
          this.titleKey = 'VERIFY_ELIGIBILITY_DEPENDENT_TITLE';
          this.bodyKey = 'VERIFY_ELIGIBILITY_DEPENDENT_DESC';
        }
        if (this.regSvc.skipAccountCreation) {
          this.titleKey = 'VERIFY_ELIGIBILITY_REFERRAL_TITLE';
          this.bodyKey = 'VERIFY_ELIGIBILITY_REFERRAL_DESC';
        }

        this.sub.add(
          this.companyService.company.subscribe(
            value => {
              if (value !== '') {
                this.company = value;
                clearTimeout(this.redirectTimeout);
              } else {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                // this.redirectTimeout = setTimeout(
                //   () => {this.router.navigate(['registration', 'select-employer']);}
                //   , 500
                // );
              }
            }
          )
        )
      }
    );
  }

  ngOnInit(): void {
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  onIdentityComplete(event: boolean) {
    this.continueToStatus()
  }

  goBack(company: string) {
    this.router.navigate(['registration', 'type']);
  }

  registrationAnalytics() {
    // this was grabbing the below 2 lines from cache again, but don't think it is necessary
    const regType = this.regType;
    const refType = this.referrerType;
    const eventProps = {'registration type': regType};
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    if (refType) eventProps['referral type'] = refType;
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    if (this.company) eventProps['company'] = this.company;
    this.analytics.logEvent('registration_completed', eventProps);
  }

  continueToStatus() {
    if (this.languageSelectSvc.activeLang !== 'en') {
      this.languageSelectSvc.use(this.languageSelectSvc.activeLang);
    }

    // we need to wait for the server to do its thing
    setTimeout(()=>{
      this.getProfileUntilResults();
    }, 500);
  }

  getProfileUntilResults() {
    this.bsAuthService.getToken().subscribe({
      next: tokenResp => {
        this.bsAuthService.fetchUserAttributes(true).subscribe({
          next: attributes => {
            if (attributes['guid']) {
              this.analytics.setUserId(attributes['guid']);
              this.bsCacheService.setItem("GUID", attributes['guid']);
              this.registrationAnalytics();
              this.router.navigate(['registration', 'status']);
            } else if (this.getProfileTimeout >= 10) {
              throw Error('Profile not updating');
            } else {
              setTimeout(()=>{
                this.getProfileTimeout++;
                this.getProfileUntilResults();
              }, 500);
            }
          }
        })
      }
    });
  }

}
